type Handler<T> = (payload: T) => void;

type RuntimeEventMap = {
  'run:reset': { runId?: string; flowId?: string };
  telemetry: unknown; // envelope compatible with useRuntimeStore.applyTelemetry
  snapshot: unknown;  // { snapshot } or plain snapshot
  end: { status: 'completed' | 'failed' | 'canceled' };
};

class TinyEmitter<EM extends Record<string, any>> {
  private m = new Map<keyof EM, Set<Function>>();

  on<K extends keyof EM>(event: K, handler: Handler<EM[K]>): () => void {
    const set = (this.m.get(event) as Set<Function> | undefined) ?? new Set();
    set.add(handler as any);
    this.m.set(event, set as any);
    return () => {
      try { (set as any).delete(handler as any); } catch {}
    };
  }

  emit<K extends keyof EM>(event: K, payload: EM[K]): void {
    const set = this.m.get(event);
    if (!set) return;
    for (const fn of Array.from(set)) {
      try { (fn as Handler<EM[K]>)(payload); } catch {}
    }
  }

  clear(): void { this.m.clear(); }
}

export const runtimeEvents = new TinyEmitter<RuntimeEventMap>();

